import map from "lodash/fp/map";
class Controller {
  constructor(GoogleMaps) {
    "ngInject";

    // This one for ng-map
    this.googleMapsUrl = GoogleMaps.getSource();

    this.getLocations = (point) => ({
      location: new window.google.maps.LatLng(
        point.location.lat,
        point.location.lng
      ),
      weight: point.weight * 5,
    });

    this.addHeatMap = (map) => {
      return new window.google.maps.visualization.HeatmapLayer({
        data: this.locations || [],
        map,
      });
    };
  }

  $onInit() {
    const _that = this;
    const gradient = [
      "rgba(0, 255, 255, 0)",
      "rgba(0, 255, 255, 1)",
      "rgba(0, 191, 255, 1)",
      "rgba(0, 127, 255, 1)",
      "rgba(0, 63, 255, 1)",
      "rgba(0, 0, 255, 1)",
      "rgba(0, 0, 223, 1)",
      "rgba(0, 0, 191, 1)",
      "rgba(0, 0, 159, 1)",
      "rgba(0, 0, 127, 1)",
      "rgba(63, 0, 91, 1)",
      "rgba(127, 0, 63, 1)",
      "rgba(191, 0, 31, 1)",
      "rgba(255, 0, 0, 1)",
    ];

    const getDistricts = (directions) => {
      return directions.reduce((acc, current) => {
        return acc.length
          ? `${acc}, ${current.polygonName}`
          : current.polygonName;
      }, "");
    };
    this.locations = map(this.getLocations)(this.data);

    this.onMapInit = (googleMap) => {
      this.map = googleMap;
      const heatmap = this.addHeatMap(googleMap);
      heatmap.set("gradient", gradient);
      heatmap.set("radius", 20);
    };

    this.showDetails = function (event, point, markerId) {
      _that.currentPoint = point;
      _that.currentDistrics = getDistricts(point.directions);
      _that.map.showInfoWindow(event, "suggestedStationInfowindow", markerId);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/heatmap/heatmap.controller.js